import { render, staticRenderFns } from "./PushList.vue?vue&type=template&id=aae10a52&scoped=true"
import script from "./PushList.vue?vue&type=script&lang=js"
export * from "./PushList.vue?vue&type=script&lang=js"
import style0 from "./PushList.vue?vue&type=style&index=0&id=aae10a52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aae10a52",
  null
  
)

export default component.exports